import React from "react";
import { Grid } from "@mui/material";
import { Card } from "components/haven-design/card";
import { getQueryParam } from "utils/url";
import { BackToLogin, SignUpLink, HavenConnectLoginLogo, LoginCardTitle, LoginCardSubtitle } from "components/login/components/shared-components";
import { loginStyles } from "./styles";

const NoAccount: React.FC = () => (
  <Grid container justifyContent="center" spacing={2} direction="row">
    <Grid size={{ xs: 12 }}>
      <HavenConnectLoginLogo />
    </Grid>

    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
    >
      <Card style={loginStyles.card}>
        <div style={loginStyles.textContainer}>
          <Grid size={{ xs: 12 }}>
            <LoginCardTitle title="No account found" />

            <LoginCardSubtitle>
              We {"don't"} have an account that matches <b>{getQueryParam("email")}</b>.<br />
            </LoginCardSubtitle>
          </Grid>

          <BackToLogin />

          <SignUpLink />
        </div>
      </Card>
    </Grid>
  </Grid>
);

export default NoAccount;
